import {
  Col,
  Flex,
  Form,
  Layout,
  message,
  Row,
  Typography,
  Image,
  Button,
} from "antd";
import loginBg from "../../assets/bg_login.png";
import logo from "../../assets/logo-siskop2mi.webp";
import pallete from "../../utils/pallete";
import { useAuth } from "../../hooks/useAuth";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { Link } from "react-router";
import { authService } from "../../services/auth.service";
import CustomTextInput from "../../components/CustomTextInput";

export default function ForgotPassword() {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { login: setLogin } = useAuth();

  // Determine if mobile based on window width
  const isMobile = windowWidth <= 768;

  // Detect window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const loginMutation = useMutation({
  //   mutationFn: (data) => authService.login(data),
  //   onSuccess: ({ data }) => {
  //     setLogin(data);
  //     window.location.href = "/";
  //   },
  //   onError: (err) => {
  //     console.error("Login error:", err);

  //     if (err.response) {
  //       const status = err.response.status;
  //       const serverMessage =
  //         err.response.data?.error || err.response.data?.message;

  //       if (status === 401) {
  //         messageApi.error(serverMessage || "Email atau password salah");
  //         return;
  //       }

  //       if (status === 404) {
  //         messageApi.error(serverMessage || "Email tidak terdaftar");
  //         return;
  //       }

  //       messageApi.error(serverMessage || `Terjadi kesalahan (${status})`);
  //       return;
  //     }

  //     messageApi.error("Email atau password tidak sesuai, silahkan coba lagi");
  //   },
  // });

  // const handleSubmit = (values) => loginMutation.mutate(values);
  // const isPending = loginMutation.isPending;
  const handleSubmit = (values) => {
    window.location.href = "/create-new-password";
  };

  // Render the welcome header for mobile devices (maintaining structure but hiding text)
  const renderWelcomeHeader = () => (
    <div
      style={{
        backgroundColor: pallete.primary[50],
        height: "150px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Flex
        vertical
        justify="center"
        align="center"
        style={{
          height: "100%",
          width: "100%",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <Typography.Title
          level={3}
          style={{
            color: "transparent",
            marginBottom: 10,
            visibility: "hidden",
          }}
        >
          Selamat Datang,
        </Typography.Title>
        <Typography.Title
          level={3}
          style={{
            color: "transparent",
            marginTop: -15,
            visibility: "hidden",
          }}
        >
          Back Office SISKOP2MI
        </Typography.Title>
      </Flex>
    </div>
  );

  return (
    <>
      {contextHolder}

      {/* Fixed copyright footer for mobile */}
      {isMobile && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            textAlign: "center",
            padding: "10px 0",
            zIndex: 1000,
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <Typography.Text style={{ color: pallete.grey[600] }}>
            ©2025. KEMENP2MI - All Rights Reserved.
          </Typography.Text>
        </div>
      )}

      <Layout
        style={{
          minHeight: "100vh",
          height: "100vh",
          position: "fixed",
          width: "100%",
          top: 0,
          left: 0,
          backgroundColor: "#fff",
          paddingBottom: isMobile ? "70px" : 0, // Add padding for fixed footer on mobile
        }}
      >
        <Row
          style={{
            height: "100%",
            overflow: "hidden",
          }}
        >
          {/* Left Column - Background Image (only on desktop) */}
          {!isMobile ? (
            <Col
              span={12}
              style={{
                backgroundImage: `url(${loginBg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                height: "100%",
                overflow: "hidden",
                position: "relative",
              }}
            ></Col>
          ) : (
            // Mobile header with background
            renderWelcomeHeader()
          )}

          {/* Right Column - Login Form */}
          <Col
            span={isMobile ? 24 : 12}
            style={{
              height: isMobile ? "calc(100% - 150px)" : "100%",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "100%",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "30px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  maxWidth: 450,
                  margin: "0 auto",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Flex justify="center" style={{ marginBottom: 32 }}>
                  <Image
                    src={logo}
                    alt="SISKOP2MI"
                    style={{ height: 72 }}
                    preview={false}
                  />
                </Flex>

                <Typography.Title
                  level={3}
                  style={{
                    fontWeight: 700,
                    margin: 0,
                    textAlign: "center",
                    marginBottom: 15,
                  }}
                >
                  Lupa Password
                </Typography.Title>

                <Typography.Text
                  style={{
                    fontWeight: 500,
                    fontSize: 14,
                    color: pallete.grey[500],
                    display: "inline-block",
                    marginBottom: 32,
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  Silahkan masukkan email yang Anda gunakan
                  <br />
                  untuk daftar
                </Typography.Text>

                <Form
                  layout="vertical"
                  requiredMark={false}
                  form={form}
                  onFinish={handleSubmit}
                  style={{ width: "100%" }}
                >
                  <CustomTextInput
                    label="Email"
                    name="email"
                    starLabel={false}
                    // disabled={isPending}
                    rules={[
                      {
                        required: true,
                        message: "Email harus diisi",
                      },
                    ]}
                  />

                  <Button
                    // loading={isPending}
                    // disabled={isPending}
                    htmlType="submit"
                    type="primary"
                    size="large"
                    block
                    style={{
                      marginTop: 16,
                    }}
                  >
                    Kirim
                  </Button>
                </Form>
              </div>
            </div>

            {/* Desktop Only Copyright */}
            {!isMobile && (
              <Typography.Text
                style={{
                  display: "block",
                  textAlign: "center",
                  padding: "20px 0",
                  color: pallete.grey[600],
                }}
              >
                ©2025. KEMENP2MI - All Rights Reserved.
              </Typography.Text>
            )}
          </Col>
        </Row>
      </Layout>
    </>
  );
}
